<template>
  <div class="main-wrapper">
    <div style="height: 5px"></div>

    <div class="message-header">
      <el-form label-position="left" inline class="table-expand">
        <el-form-item label="工单编号">
          {{ ticket.ticketNo }}
        </el-form-item>
        <el-form-item label="优先级">
          {{ getTicketPriority() }}
        </el-form-item>
        <el-form-item label="工单类型">
          {{ getTicketCategory() }}
          <span v-if="ticket.resourceId">{{ ticket.resourceId }}</span>
        </el-form-item>
        <el-form-item label="提交时间">
          <span>{{ ticket.createdDate }}</span>
        </el-form-item>
      </el-form>

      <el-form label-position="left" inline class="table-expand">
        <el-form-item label="用户名称">
          <el-link
            type="primary"
            :underline="false"
            href="javascript:;"
            @click.prevent="btnResourcesClick()"
          >
          {{ user.userName }}
          </el-link>
        </el-form-item>
        <el-form-item label="手机号码">
          <span>{{ user.mobile }}</span>
        </el-form-item>
        <el-form-item label="工单状态">
          <el-tag :type="getTicketStatusType(ticket)">{{ getTicketStatus(ticket.status) }}</el-tag>
        </el-form-item>
        <el-form-item label="">
          <el-button v-if="ticket.status === 'Closed'" type="primary" @click="btnOpenClick">重新打开</el-button>
          <el-button v-else type="danger" @click="btnCloseClick">关闭工单</el-button>
        </el-form-item>
      </el-form>
    </div>

    <message-list :isReply="true" :user="user" :messages="messages"></message-list>

    <div v-if="isInputArea()" class="message-footer">
      <el-form label-position="left" ref="form" :model="form" style="width: 100%; margin: 10px">
        <el-form-item>
          <el-upload
            :drag="true"
            :action="uploadUrl"
            :auto-upload="true"
            :headers="{ Authorization: 'Bearer ' + uploadToken }"
            :show-file-list="false"
            :before-upload="uploadBefore"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :multiple="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            :rows="2"
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="请输入内容，支持 Markdown 标签"
            v-model="form.content"
          ></el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" @click="btnSubmitClick">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-drawer title="用户资源" direction="rtl" size="80%" v-model="isResources">
      <el-row :gutter="20">
        <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
          用户：{{ user.userName }}，手机：{{ user.mobile }}
        </el-col>
      </el-row>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="hosts">
          <el-table-column label="网站云实例ID/名称">
            <template #default="scope">
              <el-link
                type="primary"
                style="margin-right: 5px"
                :underline="false"
                :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
                target="_blank"
              >
                {{ getHostName(scope.row) }}
              </el-link>
              <br v-if="scope.row.nickName" />
              <el-link :underline="false">
                {{ scope.row.nickName }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="网站云版本" width="140">
            <template #default="scope">
              {{ getHostType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="到期时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.expirationDate }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="140" align="center">
            <template #default="scope">
              {{ scope.row.isRunning ? '运行中' : '已停止' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="clouds">
          <el-table-column label="云助手版本">
            <template #default="scope">
              {{ getCloudType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="到期时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.cloudType === 'Free' ? '' : scope.row.expirationDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="themes" width="100%">
          <el-table-column label="模板名称">
            <template #default="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="150">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="价格" width="150">
            <template #default="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="extensions" width="100%">
          <el-table-column label="插件名称">
            <template #default="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="150">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="价格" width="150">
            <template #default="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
        </el-table>
      </div>

    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ITicketMessage, ITicket, IUser, IExtension, IHost, ITheme, ICloud } from '@/types/models';
import api, { ISubmitRequest, IUploadResult } from '@/api/admin/ticketMessages';
import { PER_PAGE } from '@/const';
import { MessageType, TicketStatus } from '@/types/enums';
import utils from '@/utils';
import { auth } from '@/store';
import MessageList from '@/components/tickets/MessageList.vue';

interface IForm {
  content: string;
}

interface IState {
  ticket: ITicket;
  user: IUser;
  count: number;
  messages: ITicketMessage[];
  currentPage: number;
  offset: number;
  limit: number;
  uploadToken: string;
  uploadUrl: string;
  form: IForm;
  isResources: boolean;
  hosts: IHost[];
  clouds: ICloud[];
  themes: ITheme[];
  extensions: IExtension[];
}

export default defineComponent({
  name: 'TicketMessages',
  components: { MessageList },
  data() {
    return {
      ticket: {} as ITicket,
      user: {} as IUser,
      count: 0,
      messages: [],
      currentPage: 1,
      offset: 0,
      limit: PER_PAGE,
      uploadToken: auth.token,
      uploadUrl: api.getUploadUrl(),
      form: {
        content: '',
      },
      isResources: false,
      hosts: [],
      clouds: [],
      themes: [],
      extensions: [],
    } as IState;
  },
  methods: {
    apiGet() {
      const ticketNo = this.$route?.params?.ticketNo as string;
      if (!ticketNo) return;

      api.get(
        {
          ticketNo,
        },
        (res) => {
          this.ticket = res.ticket;
          this.user = res.user;
          this.count = res.count;
          this.messages = res.messages;
        },
      );
    },

    apiSubmit(messageType: MessageType, storageKey: string, content: string) {
      const req: ISubmitRequest = {
        ticketNo: this.ticket.ticketNo,
        messageType,
        storageKey,
        content,
      };
      api.submit(req, (res) => {
        this.form.content = '';
        this.ticket.status = TicketStatus.Waiting;
        this.messages.push(res.message);
      });
    },

    apiClose() {
      api.close(
        {
          ticketNo: this.ticket.ticketNo,
        },
        (res) => {
          if (!res.value) return;
          utils.success('工单关闭成功！');
          this.ticket.status = TicketStatus.Closed;
        },
      );
    },

    apiOpen() {
      api.open(
        {
          ticketNo: this.ticket.ticketNo,
        },
        (res) => {
          if (!res.value) return;
          utils.success('工单重新打开成功！');
          this.ticket.status = TicketStatus.Dealing;
        },
      );
    },

    apiResources() {
      api.resources(this.user.id, (res) => {
        if (!res) return;

        this.isResources = true;
        this.hosts = res.hosts;
        this.clouds = res.cloud != null ? [res.cloud] : [];
        this.themes = res.themes;
        this.extensions = res.extensions;
      });
    },

    btnResourcesClick() {
      this.apiResources();
    },

    getHostName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getCloudType(cloud: ICloud) {
      return utils.getCloudType(cloud.cloudType);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getTicketPriority() {
      return utils.getTicketPriority(this.ticket.priority);
    },

    getTicketStatusType(ticket: ITicket) {
      if (ticket.status === TicketStatus.Closed) {
        return 'success';
      }
      if (ticket.status === TicketStatus.Dealing) {
        return 'danger';
      }
      return 'primary';
    },

    getTicketCategory() {
      return utils.getTicketCategory(this.ticket.category);
    },

    getTicketStatus(status: TicketStatus) {
      if (status === TicketStatus.Waiting) return '待用户回复';
      if (status === TicketStatus.Dealing) return '待处理';
      if (status === TicketStatus.Closed) return '工单已关闭';
      return '全部';
    },

    isInputArea() {
      return this.ticket.status !== TicketStatus.Closed;
    },

    btnSubmitClick() {
      if (this.form.content) {
        this.apiSubmit(MessageType.Text, '', this.form.content);
      }
    },

    btnOpenClick() {
      this.apiOpen();
    },

    btnCloseClick() {
      utils.alertDelete(
        {
          title: '关闭工单',
          text: '此操作将关闭工单，确定吗？',
          button: '确认关闭',
        },
        () => {
          this.apiClose();
        },
      );
    },

    uploadBefore(file: { size: number }) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        utils.error('文件大小不能超过 10MB!');
      }
      return isLt10M;
    },

    uploadProgress() {
      utils.loading(true);
    },

    uploadSuccess(res: IUploadResult) {
      this.apiSubmit(res.messageType, res.storageKey, res.content);
    },

    uploadError(err: { message: string }) {
      utils.loading(false);
      const error = JSON.parse(err.message);
      utils.error(error.message);
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      () => {
        this.apiGet();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true },
    );
  },
});
</script>
<style scoped>
.message-header {
  padding: 10px 15px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f5f7;
}

.table-expand {
  font-size: 0;
  width: 100%;
  display: flex;
}
.table-expand label {
  width: 90px;
  color: #fff;
}
.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 25%;
}
.table-expand .el-form-item__label {
  color: #fff;
}

.message-footer {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f5f7;
  padding-top: 20px;
  width: 100%;
  display: flex;
}
</style>
